import React, { useState, useEffect } from "react";
import arrow from "../icons/arrow_upward-24px.svg";
import "./ScrollTopButton.css";

function ScrollTopButton(props) {
	let [scrolled, setScrolled] = useState(window.pageYOffset);
	let [coords] = useState(document.documentElement.clientHeight);

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		}
	});

	function handleScroll(e) {
		setScrolled(window.pageYOffset + 500);
	}

	function onClick(e) {
		window.scrollTo(0, 0);
	}

	let buttonVisibility = scrolled > coords ? "visible" : "hidden";

	return (
		<div>
			<button
				id="btnScrollTop"
				className={`btn-scroll-top-${buttonVisibility}`}
				onClick={onClick}
			>
				<img src={arrow} alt={""} />
			</button>
		</div>
	);
}

export default ScrollTopButton;
